import React from "react";
import {Box, Button, List, Typography} from "@mui/material";
import {AccountCircle, CheckCircleOutline} from "@mui/icons-material";
import {alpha} from "@mui/material/styles";
import {getSettingsColors} from "../SettingsDesign";

export function IntegrationAdAccountList({children, provider}) {
    return (
        <List aria-label={`${provider} ad accounts`} sx={{display: "grid", gap: 1, maxHeight: 500, overflow: "auto"}}>
            {children}
        </List>
    );
}

export function IntegrationAdAccountRow({name, accountId, integrated, onIntegrate}) {
    return (
        <Box component="li" sx={{
            display: "grid",
            gridTemplateColumns: {xs: "32px minmax(0, 1fr)", sm: "32px minmax(0, 1fr) 112px"},
            alignItems: "start",
            columnGap: 1.5,
            rowGap: 1.25,
            minWidth: 0,
            p: 1.5,
            borderRadius: "10px",
            bgcolor: theme => getSettingsColors(theme).card
        }}>
            <Box sx={{display: "flex", alignItems: "center", justifyContent: "center",
                width: 32, height: 32, borderRadius: "8px",
                bgcolor: theme => getSettingsColors(theme).inset, color: "text.secondary"}}>
                <AccountCircle sx={{fontSize: 22}}/>
            </Box>
            <Box sx={{minWidth: 0, alignSelf: "center"}}>
                <Typography sx={{fontSize: 14, fontWeight: 600, lineHeight: 1.5, overflowWrap: "anywhere"}}>
                    {name || accountId}
                </Typography>
                <Typography sx={{mt: 0.25, fontSize: 12, lineHeight: 1.5, color: "text.secondary",
                    fontVariantNumeric: "tabular-nums", overflowWrap: "anywhere"}}>
                    Account ID: {accountId}
                </Typography>
            </Box>
            <Box sx={{gridColumn: {xs: 2, sm: 3}, gridRow: {sm: 1}, alignSelf: "center", minWidth: 0}}>
                {integrated ? (
                    <Box sx={{display: "flex", alignItems: "center", justifyContent: "center", gap: 0.75,
                        minHeight: 36, px: 1, borderRadius: "8px", fontSize: 13, fontWeight: 600,
                        color: "primary.main", bgcolor: theme => alpha(theme.palette.primary.main, 0.1),
                        whiteSpace: "nowrap"}}>
                        <CheckCircleOutline sx={{fontSize: 17}}/>
                        Integrated
                    </Box>
                ) : (
                    <Button onClick={onIntegrate} aria-label={`Integrate ${name || accountId}`}
                            color="primary" variant="contained" size="small" fullWidth disableElevation
                            sx={{minHeight: 36, px: 1.5, whiteSpace: "nowrap"}}>
                        Integrate
                    </Button>
                )}
            </Box>
        </Box>
    );
}
